/**
 * FT13-U28: the close certification register (FSD 2.2.8). Spread by INT into
 * the router; no module entitlement, like every close route (permissions.go
 * ModuleKey: a close is not a purchasable module).
 */

import type { RouteRecordRaw } from 'vue-router'

import { CERTIFICATION_PERMISSIONS } from '@/modules/close/certifications/api'

export const CLOSE_CERTIFICATIONS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/close/certifications',
    name: 'close-certifications',
    component: () => import('@/modules/close/certifications/CertificationsView.vue'),
    meta: { titleKey: 'close.ft13.routeTitles.certifications', permission: CERTIFICATION_PERMISSIONS.read },
  },
]
